import { Component, Optional } from "@angular/core";
import {
    transition,
    trigger,
    query,
    style,
    animate,
    group,
    animateChild
} from "@angular/animations";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "gedenkportal",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    animations: [
      trigger('routerTransition', [
        // transition('home <=> detail', [    
        transition('* <=> *', [    
        //   query(':enter, :leave', style({ position: 'fixed', width:'100%' })),
          query(':enter, :leave', style({ overflow: 'hidden', position: 'absolute', width:'100%' }),{ optional: true }),
          group([ 
            query(':enter', [
              style({ transform: 'scale(0) translateX(100%)' }),
              animate('0.5s ease-in-out', style({ transform: 'scale(1) translateX(0%)' }))], { optional: true }),
            query(':leave', [
              style({ transform: 'scale(1) translateX(0%)' }),
              animate('0.5s ease-in-out', style({ transform: 'scale(0) translateX(-100%)' }))], { optional: true }),
          ])
        ])
      ])
    ],
})
export class AppComponent {
//   @HostBinding('@routeAnimation') routeAnimation = true;
    title = "angular-gedenkportal-app";


    getState(outlet) {
      // Changing the activatedRouteData.state triggers the animation
      return outlet.activatedRouteData.state;
    }
}

